module.exports = __webpack_public_path__ + "static/media/pinterest.5a4db344.svg";